import {
  ActionModalButtonItem,
  BOX_OFFICE,
  FilteredActionModalType,
  IMPORT_CSV,
  INVITE_GUEST,
  OFFLINE_SALES,
} from '@contexts/modal/modal-context.type';
import { ACTION_MODALS } from '@contexts/modal/utils';

export const getFilteredModalActions = (enabledOptions: { [key: string]: boolean }) => {
  return Object.keys(ACTION_MODALS).reduce<Partial<Record<FilteredActionModalType, ActionModalButtonItem>>>(
    (acc, key) => {
      const isDisabled =
        (key === IMPORT_CSV && !enabledOptions.importCsv) ||
        (key === OFFLINE_SALES && !enabledOptions.offlineSale) ||
        (key === INVITE_GUEST && !enabledOptions.inviteGuest) ||
        (key === BOX_OFFICE && !enabledOptions.boxOffice);

      if (!isDisabled) {
        acc[key as FilteredActionModalType] = ACTION_MODALS[key as FilteredActionModalType];
      }

      return acc;
    },
    {}
  );
};
